module.exports = __webpack_public_path__ + "img/codeRed.b2015192.png";